/**
 * The attribution line a checkout host resolves to: whether to show one, whom to credit, the link.
 */
export type CheckoutAttribution = {
  show: boolean;
  text?: string;
  url?: string;
};

// Declared here, not generated: the backend codegen introspects predates the field.
export type CheckoutAttributionPayload = {
  show: boolean;
  text?: string | null;
  url?: string | null;
};

export const fromGql = (item?: CheckoutAttributionPayload | null): CheckoutAttribution | undefined => {
  if (!item) {
    return undefined;
  }

  return { show: item.show, text: item.text ?? undefined, url: item.url ?? undefined };
};
